/**
 * Az apihub páciens-tokenjének gyorsítótára (portal/apihub-token).
 *
 * Külön modulban, hogy az auth store is üríthesse: a token egy adott páciensé, a
 * kijelentkezés pedig nem tölti újra az oldalt — e nélkül a következő belépő (vagy a
 * vendég) a lejáratig az előző páciens tokenjével hívná az apihubot.
 */
let token = null;
let expiresAt = 0;

export function cachedPatientToken() {
    return token && Date.now() < expiresAt - 30000 ? token : null;
}

export function storePatientToken(value, expiresInSeconds) {
    token = value;
    expiresAt = Date.now() + expiresInSeconds * 1000;
}

export function clearPatientToken() {
    token = null;
    expiresAt = 0;
}
